import axios from 'axios';
import { ApiConstant } from '../constants';

export const getOpenGBFlags = async (openFeatures=[]) => {
    try {
        const response = await axios.post(
            `${ApiConstant.BASE_URL}${ApiConstant.OPEN_GB_FLAG}`,
            { openFeatures }
        );
        return response.data;
    } catch(e) {
        return null;
    }
}